module.exports = __webpack_public_path__ + "static/img/sucai3.5dacff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new4/sucai3.png
// module id = WilV
// module chunks = 5